import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
// import Datetime from "react-datetime";
// import "react-datetime/css/react-datetime.css";
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'moment/locale/fi';
import 'moment/locale/id';
import fi from 'date-fns/locale/fi';
import id from 'date-fns/locale/id';

import { getTransaction } from '../../libs/apis';

import Item from './Item';
import Loader from '../global/Loader';
registerLocale('fi', fi);
registerLocale('id', id);

export default function Calendar({ role, isWidget = false }) {
  const { t, i18n } = useTranslation();
  const lang = i18n ? i18n.language : 'en';
  moment.locale(lang);
  const today = new Date();
  const initialState = {
    data: [],
    isLoading: true,
    isError: false,
    mode: 'today',
    openMenu: false,
    date: today,
    startWeek: new Date(moment(today).startOf('isoWeek')),
    endWeek: new Date(moment(today).endOf('isoWeek')),
    calendarOpen: false,
    isRefetch: false,
  };
  const [state, setMyState] = useState(initialState);
  const setState = newState => {
    setMyState(prevState => ({ ...prevState, ...newState }));
  };
  const {
    data,
    isRefetch,
    isLoading,
    mode,
    openMenu,
    date,
    startWeek,
    endWeek,
    calendarOpen,
  } = state;

  useEffect(() => {
    const getData = async () => {
      setState({ isRefetch: true });
      let startDate = moment(startWeek).format('YYYY-MM-DD');
      let endDate = moment(endWeek).format('YYYY-MM-DD');
      if (mode === 'today') {
        startDate = moment(date).format('YYYY-MM-DD');
        endDate = moment(date).format('YYYY-MM-DD');
      } else if (mode === 'monthly') {
        startDate = moment(date).startOf('months').format('YYYY-MM-DD');
        endDate = moment(date).endOf('months').format('YYYY-MM-DD');
      }
      const payload = {
        startDate,
        endDate,
      };
      await getTransaction(payload)
        .then(res => {
          if (res.status === 200) {
            setState({ data: res.data.response });
          }
        })
        .catch(err => {
          console.log('err', err);
          setState({ isError: true });
        })
        .finally(() => setState({ isRefetch: false, isLoading: false }));
    };
    getData();
  }, [date, mode, endWeek, startWeek]);

  if (isLoading) return <Loader center size="48" />;

  const getStartWeek = newDate => {
    const sw = new Date(moment(newDate).startOf('isoWeek'));
    return sw;
  };
  const getEndWeek = newDate => {
    const ew = new Date(moment(newDate).endOf('isoWeek'));
    return ew;
  };
  const isWeekday = date => {
    // const day = date.getDay();
    // return day !== 0 && day !== 6;
    return true;
  };
  const addDays = day => {
    const d = new Date(startWeek);
    d.setDate(d.getDate() + day);
    return d;
  };
  const nextWeek = () => {
    let n = new Date(moment(date).add(1, 'days'));
    if (mode === 'today') {
      n = new Date(moment(date).add(1, 'days'));
      // while (moment(n).isoWeekday() >= 6) {
      //   n = new Date(moment(n).add(1, 'days'));
      // }
    } else if (mode === 'weekly') {
      n = new Date(moment(date).add(1, 'weeks'));
    } else if (mode === 'monthly') {
      n = new Date(moment(date).add(1, 'months'));
    }
    setState({ date: n, startWeek: getStartWeek(n), endWeek: getEndWeek(n) });
    currentDate = 1;
  };
  const prevWeek = () => {
    let n = new Date(moment(date).subtract(1, 'days'));
    if (mode === 'today') {
      n = new Date(moment(date).subtract(1, 'days'));
    } else if (mode === 'weekly') {
      n = new Date(moment(date).subtract(1, 'weeks'));
    } else if (mode === 'monthly') {
      n = new Date(moment(date).subtract(1, 'months'));
    }
    setState({ date: n, startWeek: getStartWeek(n), endWeek: getEndWeek(n) });
    currentDate = 1;
  };
  const daysInMonth = newDate => {
    const num =
      32 - new Date(newDate.getFullYear(), newDate.getMonth(), 32).getDate();
    return num;
  };
  const firstDay = newDate => {
    const fd = new Date(newDate.getFullYear(), newDate.getMonth()).getUTCDay();
    return fd;
  };
  const rows = [...Array(6)];
  const cols = [...Array(7)];
  let currentDate = 1;
  const startTime = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDay(),
    7,
  );
  const slots = [
    moment(startTime),
    moment(startTime).add(1, 'hours'),
    moment(startTime).add(2, 'hours'),
    moment(startTime).add(3, 'hours'),
    moment(startTime).add(4, 'hours'),
    moment(startTime).add(5, 'hours'),
    moment(startTime).add(6, 'hours'),
    moment(startTime).add(7, 'hours'),
    moment(startTime).add(8, 'hours'),
    moment(startTime).add(9, 'hours'),
    moment(startTime).add(10, 'hours'),
    moment(startTime).add(11, 'hours'),
    moment(startTime).add(12, 'hours'),
  ];
  const weekSlots = [
    moment(startWeek),
    moment(startWeek).add(1, 'days'),
    moment(startWeek).add(2, 'days'),
    moment(startWeek).add(3, 'days'),
    moment(startWeek).add(4, 'days'),
    moment(startWeek).add(5, 'days'),
    moment(startWeek).add(6, 'days'),
  ];
  // console.log('w', slots)
  // console.log('dim', daysInMonth(date), firstDay(date), currentDate)

  return (
    <div
      className="calendar-container mb-3 shadow"
      style={{ margin: '0 -.75rem' }}
    >
      <div className="bg-primary bg-gradient p-3">
        <h6 className="mb-0 text-light">
          <span className="fa fa-calendar me-2"></span>
          {t('schedule_text')}
        </h6>
      </div>
      <div className=" p-0">
        <div className="calendar-widget">
          <div
            className={`calendar-toolbar bg-light shadow-sm border-bottom ${
              isWidget ? '' : 'sticky-top'
            }`}
          >
            <div className="d-flex justify-content-center align-items-center p-2">
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className="btn  border bg-white"
                  onClick={prevWeek}
                >
                  <span className="fa fa-chevron-left"></span>
                </button>
                <button
                  type="button"
                  className="btn  bg-white border text-primary"
                  onClick={() => setState({ calendarOpen: !calendarOpen })}
                >
                  <span className="fa fa-calendar"></span>
                </button>
                <button
                  type="button"
                  className="btn  border bg-white"
                  onClick={nextWeek}
                >
                  <span className="fa fa-chevron-right"></span>
                </button>
              </div>
              <div
                className="current-date text-center px-2"
                style={{ flex: '1' }}
              >
                {mode === 'today' && (
                  <h6
                    className="mb-0"
                    onClick={() => setState({ calendarOpen: !calendarOpen })}
                  >
                    {moment(date).format('ddd MMM DD, YYYY')}{' '}
                    <span className="fa fa-angle-down ms-2"></span>
                  </h6>
                )}
                {mode === 'weekly' && (
                  <h6
                    className="mb-0"
                    onClick={() => setState({ calendarOpen: !calendarOpen })}
                  >
                    {moment(startWeek).format('MMM DD')} -{' '}
                    {moment(endWeek).format('DD, YYYY')}{' '}
                    <span className="fa fa-angle-down ms-2"></span>
                  </h6>
                )}
                {mode === 'monthly' && (
                  <h6
                    className="mb-0"
                    onClick={() => setState({ calendarOpen: !calendarOpen })}
                  >
                    {moment(date).format('MMMM YYYY')}{' '}
                    <span className="fa fa-angle-down ms-2"></span>
                  </h6>
                )}
              </div>
              <div className={`toolbar-menu ${openMenu ? 'is-open' : ''}`}>
                <div className="dropdown">
                  <button
                    className="btn bg-white border"
                    onClick={() => setState({ openMenu: !openMenu })}
                  >
                    <span
                      className={`fa fa-chevron-${openMenu ? 'up' : 'down'}`}
                    ></span>
                  </button>
                  <ul
                    className="dropdown-menu dropdown-menu-end"
                    style={{
                      display: `${openMenu ? 'block' : 'none'}`,
                      left: 'auto',
                      right: '0',
                    }}
                  >
                    <li>
                      <button
                        className={`dropdown-item ${
                          mode === 'today' ? 'active' : ''
                        }`}
                        onClick={() =>
                          setState({
                            mode: 'today',
                            date: new Date(),
                            openMenu: false,
                          })
                        }
                      >
                        {t('calendar_today')}
                      </button>
                    </li>
                    <li>
                      <button
                        className={`dropdown-item ${
                          mode === 'weekly' ? 'active' : ''
                        }`}
                        onClick={() =>
                          setState({
                            mode: 'weekly',
                            date: new Date(),
                            startWeek: moment().startOf('isoWeek'),
                            endWeek: moment().endOf('isoWeek'),
                            openMenu: false,
                          })
                        }
                      >
                        {t('calendar_weekly')}
                      </button>
                    </li>
                    <li>
                      <button
                        className={`dropdown-item ${
                          mode === 'monthly' ? 'active' : ''
                        }`}
                        onClick={() =>
                          setState({
                            mode: 'monthly',
                            date: new Date(),
                            startWeek: moment().startOf('month'),
                            endWeek: moment().endOf('month'),
                            openMenu: false,
                          })
                        }
                      >
                        {t('calendar_monthly')}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {calendarOpen && (
              <div className={`calendar-object pt-1 text-center `}>
                {(mode === 'today' || mode === 'weekly') && (
                  <DatePicker
                    selected={date}
                    locale={lang}
                    onChange={date => {
                      const startDate = new Date(
                        moment(date).startOf('isoWeek'),
                      );
                      const endDate = new Date(moment(date).endOf('isoWeek'));
                      setState({
                        date: date,
                        startWeek: startDate,
                        endWeek: endDate,
                        calendarOpen: false,
                      });
                    }}
                    highlightDates={
                      mode === 'weekly'
                        ? [
                            startWeek,
                            addDays(1),
                            addDays(2),
                            addDays(3),
                            addDays(4),
                            addDays(5),
                            addDays(6),
                          ]
                        : []
                    }
                    filterDate={isWeekday}
                    inline
                  />
                )}
                {mode === 'monthly' && (
                  <DatePicker
                    selected={date}
                    locale={lang}
                    onChange={date => {
                      const startDate = new Date(
                        moment(date).startOf('isoWeek'),
                      );
                      const endDate = new Date(moment(date).endOf('isoWeek'));
                      setState({
                        date: date,
                        startWeek: startDate,
                        endWeek: endDate,
                        calendarOpen: false,
                      });
                    }}
                    showMonthYearPicker
                    showFullMonthYearPicker
                    // highlightDates={mode === 'weekly' ? [startWeek, addDays(1), addDays(2), addDays(3), addDays(4)] : []}
                    // filterDate={isWeekday}
                    inline
                  />
                )}
                {/* <Datetime input={false} id="datepicker" initialValue={date} closeOnSelect={true} dateFormat="MMM DD, YYYY" timeFormat={false} onChange={(e) => {
                  const startDate = e.startOf('isoWeek');
                  const endDate = e.endOf('isoWeek');
                  setState({ date: e, startWeek: startDate, endWeek: endDate, calendarOpen: false })
                }} /> */}
              </div>
            )}
            {mode === 'today' && (
              <table
                className="table table-bordered border-bottom-0 table-sm m-0"
                style={{ background: '#f3f9f6' }}
              >
                <thead
                  className="text-center"
                  style={{ background: '#f3f9f6' }}
                >
                  <tr className="border-0">
                    <th
                      scope="col"
                      style={{ width: '15%' }}
                      className="fs-12 fw-normal border border-bottom-0 p-0 py-2"
                    ></th>
                    <th
                      scope="col"
                      style={{ width: '85%' }}
                      className="fs-12 fw-normal border border-bottom-0 p-0 py-2"
                    >
                      {moment(date).format('ddd MMM DD, YYYY')}
                    </th>
                  </tr>
                </thead>
              </table>
            )}
            {mode === 'weekly' && (
              <div className="table-container">
                <table
                  className="table table-bordered border-bottom-0 table-sm m-0"
                  style={{ background: '#f3f9f6' }}
                >
                  <thead
                    className="text-center"
                    style={{ background: '#f3f9f6' }}
                  >
                    <tr className="border-0">
                      <th
                        scope="col"
                        style={{ width: '12.5%' }}
                        className="fs-12 fw-normal border border-bottom-0 p-0 py-2"
                      >
                        W{moment(date).isoWeek()}
                      </th>
                      <th
                        scope="col"
                        style={{ width: '12.5%' }}
                        className="fs-12 fw-normal border border-bottom-0 p-0 py-2"
                        onClick={() => {
                          const newDate = new Date(
                            moment(weekSlots[0]).format('MM/DD/YYYY'),
                          );
                          setState({ mode: 'today', date: newDate });
                        }}
                      >
                        {moment(weekSlots[0]).format('MMM DD')}
                      </th>
                      <th
                        scope="col"
                        style={{ width: '12.5%' }}
                        className="fs-12 fw-normal border border-bottom-0 p-0 py-2"
                        onClick={() => {
                          const newDate = new Date(
                            moment(weekSlots[1]).format('MM/DD/YYYY'),
                          );
                          setState({ mode: 'today', date: newDate });
                        }}
                      >
                        {moment(weekSlots[1]).format('MMM DD')}
                      </th>
                      <th
                        scope="col"
                        style={{ width: '12.5%' }}
                        className="fs-12 fw-normal border border-bottom-0 p-0 py-2"
                        onClick={() => {
                          const newDate = new Date(
                            moment(weekSlots[2]).format('MM/DD/YYYY'),
                          );
                          setState({ mode: 'today', date: newDate });
                        }}
                      >
                        {moment(weekSlots[2]).format('MMM DD')}
                      </th>
                      <th
                        scope="col"
                        style={{ width: '12.5%' }}
                        className="fs-12 fw-normal border border-bottom-0 p-0 py-2"
                        onClick={() => {
                          const newDate = new Date(
                            moment(weekSlots[3]).format('MM/DD/YYYY'),
                          );
                          setState({ mode: 'today', date: newDate });
                        }}
                      >
                        {moment(weekSlots[3]).format('MMM DD')}
                      </th>
                      <th
                        scope="col"
                        style={{ width: '12.5%' }}
                        className="fs-12 fw-normal border border-bottom-0 p-0 py-2"
                        onClick={() => {
                          const newDate = new Date(
                            moment(weekSlots[4]).format('MM/DD/YYYY'),
                          );
                          setState({ mode: 'today', date: newDate });
                        }}
                      >
                        {moment(weekSlots[4]).format('MMM DD')}
                      </th>
                      <th
                        scope="col"
                        style={{ width: '12.5%' }}
                        className="fs-12 fw-normal border border-bottom-0 p-0 py-2"
                        onClick={() => {
                          const newDate = new Date(
                            moment(weekSlots[5]).format('MM/DD/YYYY'),
                          );
                          setState({ mode: 'today', date: newDate });
                        }}
                      >
                        {moment(weekSlots[5]).format('MMM DD')}
                      </th>
                      <th
                        scope="col"
                        style={{ width: '12.5%' }}
                        className="fs-12 fw-normal border border-bottom-0 p-0 py-2"
                        onClick={() => {
                          const newDate = new Date(
                            moment(weekSlots[6]).format('MM/DD/YYYY'),
                          );
                          setState({ mode: 'today', date: newDate });
                        }}
                      >
                        {moment(weekSlots[6]).format('MMM DD')}
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
              // <div className="week-header border-top border-left border-right bg-gradient shadow-sm" style={{ background: '#f3f9f6' }}>
              //   <div className="grid-view">
              //     <div className="c-rows">
              //       <div className="c-row d-flex">
              //         <div className="c-head left-col">W{moment(date).isoWeek()}</div>
              //         <div className="c-head border-start calendar-date today">{moment(startWeek).format('MMM DD')}</div>
              //         <div className="c-head border-start calendar-date">{moment(addDays(1)).format('MMM DD')}</div>
              //         <div className="c-head border-start calendar-date">{moment(addDays(2)).format('MMM DD')}</div>
              //         <div className="c-head border-start calendar-date">{moment(addDays(3)).format('MMM DD')}</div>
              //         <div className="c-head border-start calendar-date">{moment(addDays(4)).format('MMM DD')}</div>
              //       </div>
              //     </div>
              //   </div>
              // </div>
            )}
          </div>
          {isRefetch ? (
            <div className="text-center p-5 vh-100">
              <Loader size="24" color="warning" />
            </div>
          ) : (
            <div className="calendar-body">
              {mode === 'today' && (
                <div className="today-view">
                  <div className="table-container">
                    <table className="table table-bordered table-sm bg-white">
                      <thead>
                        <tr className="border-bottom-0 border-top-0">
                          <th
                            scope="col"
                            style={{ width: '15%', height: '0' }}
                            className="p-0"
                          />
                          <th
                            scope="col"
                            style={{ width: '85%', height: '0' }}
                            className="p-0"
                          />
                        </tr>
                      </thead>
                      {/* <thead className="text-center" style={{ background: '#f3f9f6' }}>
                    <th style={{ width: '64px' }} className="fs-12 fw-normal border p-0 py-2">W{moment(date).isoWeek()}</th>
                    <th className="fs-12 fw-normal border p-0 py-2">{moment(startWeek).format('MMM DD')}</th>
                    <th className="fs-12 fw-normal border p-0 py-2">{moment(addDays(1)).format('MMM DD')}</th>
                    <th className="fs-12 fw-normal border p-0 py-2">{moment(addDays(2)).format('MMM DD')}</th>
                    <th className="fs-12 fw-normal border p-0 py-2">{moment(addDays(3)).format('MMM DD')}</th>
                    <th className="fs-12 fw-nor
                    mal border p-0 py-2">{moment(addDays(4)).format('MMM DD')}</th>
                  </thead> */}
                      <tbody className="">
                        {slots.map((time, i) => {
                          const hasOrder = data.length > 0;
                          return (
                            <tr
                              key={i}
                              className={i === 0 ? 'border-top-0' : ''}
                            >
                              <th
                                valign="middle"
                                className={`border fs-12 p-1 py-2 text-end bg-light fw-normal font-ssp ${
                                  i === 0 ? 'border-top-0' : ''
                                }`}
                              >
                                {time.format('h A')}
                              </th>
                              <td className="p-0">
                                {/* <div className="c-cell">
                                  <div className="cell"></div>
                                  <div className="cell"></div>
                                </div> */}
                                {hasOrder && (
                                  <div className="order-boxes-container">
                                    {data.map((o, iii) => {
                                      const orderTime = moment(
                                        o.transaction_request[0].datetime,
                                      ).format('HH');
                                      if (
                                        o.transaction_request[0].status === 1 &&
                                        o.type === 2
                                      ) {
                                        return null;
                                      }
                                      if (orderTime === time.format('HH')) {
                                        return (
                                          <div className="order-box" key={iii}>
                                            <Item
                                              data={o}
                                              timeslot={moment(
                                                o.transaction_request[0]
                                                  .datetime,
                                              ).format()}
                                            />
                                          </div>
                                        );
                                      } else {
                                        return null;
                                      }
                                    })}
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {mode === 'weekly' && (
                <div className="week-view">
                  <div className="table-container table-responsive">
                    <table className="table table-bordered table-responsive table-sm bg-white">
                      <thead>
                        <tr className="border-bottom-0 border-top-0">
                          <th
                            scope="col"
                            style={{ width: '12.5%', height: '0' }}
                            className="p-0"
                          />
                          <th
                            scope="col"
                            style={{ width: '12.5%', height: '0' }}
                            className="p-0"
                          />
                          <th
                            scope="col"
                            style={{ width: '12.5%', height: '0' }}
                            className="p-0"
                          />
                          <th
                            scope="col"
                            style={{ width: '12.5%', height: '0' }}
                            className="p-0"
                          />
                          <th
                            scope="col"
                            style={{ width: '12.5%', height: '0' }}
                            className="p-0"
                          />
                          <th
                            scope="col"
                            style={{ width: '12.5%', height: '0' }}
                            className="p-0"
                          />
                          <th
                            scope="col"
                            style={{ width: '12.5%', height: '0' }}
                            className="p-0"
                          />
                          <th
                            scope="col"
                            style={{ width: '12.5%', height: '0' }}
                            className="p-0"
                          />
                        </tr>
                      </thead>
                      {/* <thead className="text-center" style={{ background: '#f3f9f6' }}>
                    <th style={{ width: '64px' }} className="fs-12 fw-normal border p-0 py-2">W{moment(date).isoWeek()}</th>
                    <th className="fs-12 fw-normal border p-0 py-2">{moment(startWeek).format('MMM DD')}</th>
                    <th className="fs-12 fw-normal border p-0 py-2">{moment(addDays(1)).format('MMM DD')}</th>
                    <th className="fs-12 fw-normal border p-0 py-2">{moment(addDays(2)).format('MMM DD')}</th>
                    <th className="fs-12 fw-normal border p-0 py-2">{moment(addDays(3)).format('MMM DD')}</th>
                    <th className="fs-12 fw-nor
                    mal border p-0 py-2">{moment(addDays(4)).format('MMM DD')}</th>
                  </thead> */}
                      <tbody className="">
                        {slots.map((time, i) => {
                          return (
                            <tr
                              key={i}
                              className={i === 0 ? 'border-top-0' : ''}
                            >
                              <th
                                valign="middle"
                                className={`border fs-12 p-1 py-2 text-end bg-light fw-normal font-ssp ${
                                  i === 0 ? 'border-top-0' : ''
                                }`}
                                style={{ width: '64px' }}
                              >
                                {time.format('h A')}
                              </th>
                              {weekSlots.map((w, ii) => {
                                const hasOrder = data.filter(
                                  d =>
                                    d.confirmation_date ===
                                    w.format('YYYY-MM-DD'),
                                );
                                return (
                                  <td key={ii} className="p-0">
                                    {hasOrder.map((o, iii) => {
                                      const orderTime = moment(
                                        o.transaction_request[0].datetime,
                                      ).format('HH');
                                      if (
                                        o.transaction_request[0].status === 1 &&
                                        o.type === 2
                                      ) {
                                        return null;
                                      }
                                      if (orderTime === time.format('HH')) {
                                        return (
                                          <div className="order-box" key={iii}>
                                            <Item
                                              data={o}
                                              timeslot={moment(
                                                o.transaction_request[0]
                                                  .datetime,
                                              ).format()}
                                            />
                                          </div>
                                        );
                                      } else {
                                        return null;
                                      }
                                    })}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  {/* <div className="week-body bg-white">
                    <div className="grid-view position-relative">
                      <div className="c-rows">
                        <div className="c-row d-flex border-bottom">
                          <div className="c-cell left-col bg-light text-end small">7am</div>
                          <div className="c-cell border-start">
                            <div className="c-cell-item"></div>
                            <div className="c-cell-item cell-border"></div>
                          </div>
                        </div>
                        <div className="c-row d-flex border-bottom">
                          <div className="c-cell left-col bg-light text-end small">8am</div>
                          <div className="c-cell border-start">
                            <div className="c-cell-item"></div>
                            <div className="c-cell-item cell-border"></div>
                          </div>
                        </div>
                        <div className="c-row d-flex border-bottom">
                          <div className="c-cell left-col bg-light text-end small">9am</div>
                          <div className="c-cell border-start">
                            <div className="c-cell-item"></div>
                            <div className="c-cell-item cell-border"></div>
                          </div>
                        </div>
                        <div className="c-row d-flex border-bottom">
                          <div className="c-cell left-col bg-light text-end small">10am</div>
                          <div className="c-cell border-start">
                            <div className="c-cell-item"></div>
                            <div className="c-cell-item cell-border"></div>
                          </div>
                        </div>
                        <div className="c-row d-flex border-bottom">
                          <div className="c-cell left-col bg-light text-end small">11am</div>
                          <div className="c-cell border-start">
                            <div className="c-cell-item"></div>
                            <div className="c-cell-item cell-border"></div>
                          </div>
                        </div>
                        <div className="c-row d-flex border-bottom">
                          <div className="c-cell left-col bg-light text-end small">12pm</div>
                          <div className="c-cell border-start">
                            <div className="c-cell-item"></div>
                            <div className="c-cell-item cell-border"></div>
                          </div>
                        </div>
                        <div className="c-row d-flex border-bottom">
                          <div className="c-cell left-col bg-light text-end small">1pm</div>
                          <div className="c-cell border-start">
                            <div className="c-cell-item"></div>
                            <div className="c-cell-item cell-border"></div>
                          </div>
                        </div>
                        <div className="c-row d-flex border-bottom">
                          <div className="c-cell left-col bg-light text-end small">2pm</div>
                          <div className="c-cell border-start">
                            <div className="c-cell-item"></div>
                            <div className="c-cell-item cell-border"></div>
                          </div>
                        </div>
                        <div className="c-row d-flex border-bottom">
                          <div className="c-cell left-col bg-light text-end small">3pm</div>
                          <div className="c-cell border-start">
                            <div className="c-cell-item"></div>
                            <div className="c-cell-item cell-border"></div>
                          </div>
                        </div>
                        <div className="c-row d-flex border-bottom">
                          <div className="c-cell left-col bg-light text-end small">4pm</div>
                          <div className="c-cell border-start">
                            <div className="c-cell-item"></div>
                            <div className="c-cell-item cell-border"></div>
                          </div>
                        </div>
                        <div className="c-row d-flex border-bottom">
                          <div className="c-cell left-col bg-light text-end small">5pm</div>
                          <div className="c-cell border-start">
                            <div className="c-cell-item"></div>
                            <div className="c-cell-item cell-border"></div>
                          </div>
                        </div>
                        <div className="c-row d-flex border-bottom">
                          <div className="c-cell left-col bg-light text-end small">6pm</div>
                          <div className="c-cell border-start">
                            <div className="c-cell-item"></div>
                            <div className="c-cell-item cell-border"></div>
                          </div>
                        </div>
                      </div>
                      <div className="c-cols">
                        {[...Array(5)].map((c, i) => {
                          const thisDate = moment(startWeek).add(i, 'days').format('YYYY-MM-DD')
                          const hasOrder = data.filter(d => d.confirmation_date === thisDate);
                          if (hasOrder.length === 0) {
                            return (
                              <div className="c-col border-start" key={i}></div>
                            )
                          }
                          return (
                            <div className="c-col border-start" key={i}>
                              {hasOrder.map((o, idx) => {
                                return (
                                  <Item data={o} />
                                )
                              })}
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </div> */}
                </div>
              )}
              {mode === 'monthly' && (
                <div className="monthly-view">
                  <div className="monthly-body bg-light">
                    <div className="grid-view position-relative">
                      <div className="montly-grid">
                        <table className="table table-bordered">
                          <thead
                            className="text-center"
                            style={{ background: '#f3f9f6' }}
                          >
                            <tr>
                              <th
                                style={{ width: '14.29%' }}
                                className="border fw-normal fs-14 py-2"
                              >
                                {weekSlots[0].format('ddd')}
                              </th>
                              <th
                                style={{ width: '14.29%' }}
                                className="border fw-normal fs-14 py-2"
                              >
                                {weekSlots[1].format('ddd')}
                              </th>
                              <th
                                style={{ width: '14.29%' }}
                                className="border fw-normal fs-14 py-2"
                              >
                                {weekSlots[2].format('ddd')}
                              </th>
                              <th
                                style={{ width: '14.29%' }}
                                className="border fw-normal fs-14 py-2"
                              >
                                {weekSlots[3].format('ddd')}
                              </th>
                              <th
                                style={{ width: '14.29%' }}
                                className="border fw-normal fs-14 py-2"
                              >
                                {weekSlots[4].format('ddd')}
                              </th>
                              <th
                                style={{ width: '14.29%' }}
                                className="border fw-normal fs-14 py-2"
                              >
                                {weekSlots[5].format('ddd')}
                              </th>
                              <th
                                style={{ width: '14.29%' }}
                                className="border fw-normal fs-14 py-2"
                              >
                                {weekSlots[6].format('ddd')}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {rows.map((row, i) => {
                              let r = i;
                              return (
                                <tr className="month-row" key={i}>
                                  {cols.map((col, idx) => {
                                    let c = idx;
                                    const thisDate = moment(
                                      new Date(
                                        date.getFullYear(),
                                        date.getMonth(),
                                        currentDate,
                                      ),
                                    );
                                    const xyz = thisDate.isoWeekday();
                                    const first = firstDay(date);
                                    const hasOrder = data.filter(
                                      d =>
                                        d.confirmation_date ===
                                        thisDate.format('YYYY-MM-DD'),
                                    );
                                    if (r === 0 && c < first && first < 7) {
                                      return (
                                        <td
                                          className="month-col bg-light"
                                          key={idx}
                                        >
                                          <div className="col-date text-end"></div>
                                        </td>
                                      );
                                    } else if (
                                      currentDate > daysInMonth(date)
                                    ) {
                                      return null;
                                    } else if (xyz > 7) {
                                      currentDate++;
                                      return null;
                                    } else {
                                      const renderDate = currentDate;
                                      currentDate++;
                                      return (
                                        <td
                                          className="bg-white month-col p-1"
                                          key={idx}
                                        >
                                          <div className="col-date text-end text-muted fw-bold opacity-50">
                                            {renderDate}
                                          </div>
                                          <div
                                            className="order-box overflow-hidden text-break"
                                            style={{ minHeight: '40px' }}
                                          >
                                            {hasOrder.length > 0 &&
                                              hasOrder.map((o, ii) => {
                                                const orderTime = moment(
                                                  o.transaction_request[0]
                                                    .datetime,
                                                );
                                                if (
                                                  o.transaction_request[0]
                                                    .status === 1 &&
                                                  o.type === 2
                                                ) {
                                                  return null;
                                                }
                                                return (
                                                  <div
                                                    className="order-item"
                                                    key={ii}
                                                  >
                                                    {o.transaction_items
                                                      .length === 1 ? (
                                                      <>
                                                        <Item
                                                          data={o}
                                                          single
                                                          timeslot={orderTime}
                                                        />
                                                      </>
                                                    ) : (
                                                      <>
                                                        <Item
                                                          data={o}
                                                          timeslot={orderTime}
                                                        />
                                                      </>
                                                    )}
                                                  </div>
                                                );
                                              })}
                                          </div>
                                        </td>
                                      );
                                    }
                                  })}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="calendar-widget d-none">
          <div className="calendar-header d-flex align-items-center justify-content-between">
            <button className="btn">
              <span className="fa fa-chevron-left"></span>
            </button>
            <h6 className="mb-0 flex-1">March 2021</h6>
            <button className="btn">
              <span className="fa fa-chevron-right"></span>
            </button>
          </div>
          <div className="calendar-body border-top d-flex justify-content-between">
            <div className="calendar-time border-right">
              <div className="calendar-th">
                <h6 className="btn small text-uppercase mb-0">Time</h6>
              </div>
              <div className="time-slot text-center p-2 border-top">07 am</div>
              <div className="time-slot text-center p-2">08 am</div>
              <div className="time-slot text-center p-2">09 am</div>
              <div className="time-slot text-center p-2">10 am</div>
              <div className="time-slot text-center p-2">11 am</div>
              <div className="time-slot text-center p-2">12 pm</div>
              <div className="time-slot text-center p-2">13 pm</div>
              <div className="time-slot text-center p-2">14 pm</div>
              <div className="time-slot text-center p-2">15 pm</div>
              <div className="time-slot text-center p-2">16 pm</div>
              <div className="time-slot text-center p-2">17 pm</div>
              <div className="time-slot text-center p-2">18 pm</div>
            </div>
            <div className="calendar-order" style={{ flex: '1' }}>
              <div className="calendar-day-head d-flex justify-content-between border-bottom position-relative">
                <div className="calendar-th flex-fill p-2 border-start text-center">
                  <h6 className="small text-uppercase mb-0">22</h6>
                </div>
                <div className="calendar-th flex-fill p-2 border-start text-center">
                  <h6 className="small text-uppercase mb-0">23</h6>
                </div>
                <div className="calendar-th flex-fill p-2 border-start text-center">
                  <h6 className="small text-uppercase mb-0">24</h6>
                </div>
                <div className="calendar-th flex-fill p-2 border-start text-center">
                  <h6 className="small text-uppercase mb-0">25</h6>
                </div>
                <div className="calendar-th flex-fill p-2 border-start text-center">
                  <h6 className="small text-uppercase mb-0">26</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
